import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Loading from '../components/Loading'
import OnboardForm from './OnboardForm'
import DemoApp from './DemoApp'
import EHRSearch from './EHRSearch'
import EHRCheck from './EHRCheck'
import GetSuki from './GetSuki'
import { REGISTER_STAGE } from '../constants'
import { submitDemo, validateTokenForRegisterPage, registerUser } from '../../../rest'
import { getFullName } from '@sukiai/utils'
import {
  ROUTES,
  EMR_TYPE
} from '../../../lib'
import StepProgress from '../components/StepProgress'
import { Card } from '../components/styles'

const dontShowCard = ['DEMO_EMAIL', 'EMR_NOTES_VERIFIED', 'GET_SUKI']
class SelfOnboardForm extends Component {
  state = {
    registerStage: null,
    isLoading: true,
    isFormLoading: false,
    email: '',
    practiceName: '',
    token: null,
    organizationId: '',
    emr: '',
    sukiUserId: null,
    emrUser: null,
    bypassEMR: null,
    phoneNumber: ''
  }

  async componentDidMount () {
    // get param values
    const { history } = this.props
    const queryParams = new URLSearchParams(this.props.location.search)
    const email = queryParams.get('email')
    const token = queryParams.get('token')

    // if email or token DNE, error out
    if ((!email || !token)) {
      history.push(ROUTES.HOME)
      return
    }

    this.validateTokenRegistration(email, token)
  }

  validateTokenRegistration = async (email, token) => {
    // makes verification token call
    // update state
    const { history } = this.props

    await validateTokenForRegisterPage(email, token).then(async (res) => {
      const { user, status, practiceName, emr, emrUser, sukiUserId } = res
      this.setState({
        email,
        token,
        isLoading: false,
        sukiUserId: sukiUserId,
        emr,
        user,
        practiceName: practiceName,
        registerStage: status,
        organizationId: user?.organizationId,
        emrUser
      })
    }).catch((err) => {
      console.error(err)
      history.push('/')
    })
  }

  handleBypassEMR = () => {
    this.setState({ bypassEMR: true, registerStage: REGISTER_STAGE.EMR_LINKED })
  }

  onFormCompletion = (values) => {
    const { history } = this.props

    const { token, organizationId, registerStage, emr, email } = this.state
    const formValues = { ...values, token, organizationId }
    if (emr) {
      formValues.emr = emr
    }

    this.setState({ isFormLoading: true })
    registerUser(formValues).then((res) => {
      const { status } = res
      const isAthena = emr?.type === EMR_TYPE.ATHENA
      if (status === 200) {
        if (registerStage === REGISTER_STAGE.DEFAULT_STAGE) {
          // push to success page, done
          history.push(ROUTES.REGISTER_SUCCESS)
        } else if (!isAthena) {
          this.setState({ registerStage: REGISTER_STAGE.GET_SUKI, phoneNumber: values.phoneNumber })
        } else if (isAthena) {
          // verify token to new id + states
          this.validateTokenRegistration(email, token)
        }
      } else {
        history.push(ROUTES.REGISTER_ERROR)
      }
    })
  }

  onHandleStart = () => {
    const { email, token } = this.state
    // update registration stage + send call to backend
    submitDemo(email, token)
    this.setState({ registerStage: 'DEMO_SUBMIT' })
  }

  onHandleFinishedCheck = () => {
    this.setState({ registerStage: REGISTER_STAGE.GET_SUKI })
  }

  handleFinishedLink = (emrUser) => {
    this.setState({ emrUser, registerStage: REGISTER_STAGE.EMR_LINKED })
  }

  handleFailedChecks = (errorType) => {
    this.setState({ errorType })
  }

  renderContainer = () => {
    const { history } = this.props
    const {
      user,
      emr,
      practiceName,
      isFormLoading,
      isLoading,
      registerStage,
      organizationId,
      token,
      email,
      sukiUserId,
      emrUser,
      bypassEMR,
      phoneNumber
    } = this.state

    if (isLoading) {
      return <Loading />
    }

    switch (registerStage) {
      case REGISTER_STAGE.DEFAULT_STAGE:
        return (
          <OnboardForm
            initialValues={{
              ...user, practiceName
            }}
            isFormLoading={isFormLoading}
            handleFormCompletion={this.onFormCompletion}
          />
        )

      case REGISTER_STAGE.DEMO_EMAIL:
        return (
          <DemoApp
            handleStart={this.onHandleStart}
          />
        )

      case REGISTER_STAGE.DEMO_SUBMIT:
        return (
          <OnboardForm
            initialValues={{
              ...user, practiceName
            }}
            hasOrg={!!user?.organizationId}
            isFormLoading={isFormLoading}
            handleFormCompletion={this.onFormCompletion}
          />
        )

      case REGISTER_STAGE.REGISTER_SUBMIT:
      case REGISTER_STAGE.EMR_SEARCH:
        return (
          <EHRSearch
            intialName={getFullName(user.person)}
            token={token}
            email={email}
            organizationId={organizationId}
            emr={emr}
            sukiUserId={sukiUserId}
            timezone={user?.timezone}
            onHandleBypassEMR={this.handleBypassEMR}
            onFinishedLinkingUser={this.handleFinishedLink}
          />
        )

      case REGISTER_STAGE.EMR_LINKED:
      case REGISTER_STAGE.EMR_APPTS_VERIFIED:
        return (
          <EHRCheck
            bypassEMR={bypassEMR}
            user={user}
            emr={emr}
            email={email}
            token={token}
            organizationId={organizationId}
            emrUser={emrUser}
            handleFinishedChecks={this.onHandleFinishedCheck}
          />
        )
      case REGISTER_STAGE.EMR_NOTES_VERIFIED:
      case REGISTER_STAGE.GET_SUKI:
        return (
          <GetSuki
            history={history}
            user={user}
            phoneNumber={user?.phoneNumber || phoneNumber}
          />
        )
    }
  }

  render () {
    const {
      isScrolledDown
    } = this.props
    const {
      isLoading,
      registerStage,
      emr
    } = this.state

    const isBlankBg = dontShowCard.includes(registerStage)
    const isAthena = emr?.type === EMR_TYPE.ATHENA

    if (isLoading) {
      return <Loading />
    }

    return (
      <div>
        <Card blank={isBlankBg}>
          {isAthena && <StepProgress registerStage={registerStage} isScrolledDown={isScrolledDown} />}
          {this.renderContainer()}
        </Card>
      </div>
    )
  }
}

export default withRouter(SelfOnboardForm)
